import { useState, useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import PageService from '../../services/PageService'

const EditPresetModal = ({
  editPresetOpen,
  setEditPresetOpen,
  pagesToggler,
  setPagesToggler,
  presetToEdit
}) => {
  const [newName, setNewName] = useState('')
  const [newNameError, setNewNameError] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setNewName(presetToEdit.name)
  }, [presetToEdit.name])

  const handleCloseDeleteDialog = () => {
    setEditPresetOpen(false)
  }

  const handleNameChange = (e) => {
    setNewName(e.target.value)

    if (newNameError) {
      setNewNameError('')
    }
  }

  const handleDeletePreset = async () => {
    try {
      setDeleteLoading(true)
      await PageService.deletePreset(presetToEdit.id)
      setPagesToggler(!pagesToggler)
      setEditPresetOpen(false)
    } catch (error) {
      console.log(error)
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleSavePreset = async () => {
    if (!newName.trim()) {
      setNewNameError('Name is required.')
      return
    } else {
      setNewNameError('')
    }

    try {
      setLoading(true)
      await PageService.updatePreset(presetToEdit.id, newName)
      setPagesToggler(!pagesToggler)
      setEditPresetOpen(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={editPresetOpen} onClose={handleCloseDeleteDialog}>
      <Box className="editPresetModal">
        <DialogTitle className="editPresetModalTitle">
          Edit Selection Preset
        </DialogTitle>
        <DialogContent className="editPresetModalContent">
          <Typography variant='body1' mb={2}>
            Please edit the name of selection preset
          </Typography>
          <TextField
            label="Preset Name *"
            type="text"
            fullWidth
            variant="outlined"
            value={newName}
            onChange={handleNameChange}
            error={!!newNameError}
            helperText={newNameError + ' '}
          />
        </DialogContent>
        <DialogActions className="editPresetModalActions">
          {deleteLoading ? (
            <LoadingButton
              loading
              className="deletePresetModalButton loadingButton"
              loadingIndicator={<CircularProgress color="error" size={16} />}
            />
          ) : (
            <Button className='deletePresetModalButton' onClick={handleDeletePreset} color="error" variant="outlined">
              <DeleteOutlineOutlinedIcon color='error' />
            </Button>
          )}
          <Button className="editPresetModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="editPresetModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="editPresetModalButton" onClick={handleSavePreset} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default EditPresetModal